import { createStore, applyMiddleware, compose } from "redux";
import reducers from "../reducers";
import thunk from 'redux-thunk';
import { THEME_CONFIG } from "configs/AppConfig";
// import createSagaMiddleware from "redux-saga";
// import rootSaga from "../sagas/index";

// const sagaMiddleware = createSagaMiddleware();

// const middlewares = [sagaMiddleware];

function configureStore(preloadedState) {
 
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(reducers, preloadedState, composeEnhancers(
    applyMiddleware(thunk)
  ));

  // sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept("../reducers/index", () => {
      const nextRootReducer = require("../reducers/index");
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

// Initialize store with default theme state
const initialThemeState = {
  theme: {
    ...THEME_CONFIG,
    locale: THEME_CONFIG.locale || 'en' // Ensure locale is always set
  }
};

const store = configureStore(initialThemeState);

export default store;


// import { createStore, applyMiddleware } from 'redux';
// import thunk from 'redux-thunk';
// import rootReducer from '../reducers';

// export default function configureStore(initialState={}) {
//  return createStore(
//    rootReducer,
//    initialState,
//    applyMiddleware(thunk)
//  );
// }

